import { IWindow } from "../types/interfaces";
import { Types } from "./Types";

export function getWindow(): IWindow {
    return Types.convertType<IWindow>(window)
}
